export default __webpack_public_path__ + "static/media/7.29c58cae.png";